// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"OWa0pOQSg3ReVmu+a5A7Sg==","sm":"NAjsFyOd5vb9WoSP3Ijeng==","lg":"dAfMkCKqMV+5hAOnSyKx0g=="};